import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const SalesTurnoverFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. How does Sales Turnover Insurance work?",
      answer: (
        <>
          Sales Turnover Insurance (STOP) simplifies cargo insurance for businesses. Unlike traditional policies that cover individual shipments, STOP offers a blanket policy for your entire sales cycle. This means your goods are insured from buying raw materials to delivering finished products to customers, including domestic purchases, imports, exports, and even temporary storage. <span style={{ color: "#F37435", fontWeight: "700"}}>You agree on an annual sales turnover limit with your insurer and pay premiums based on that, eliminating the need for constant quotes and paperwork.</span>

        </>
      )
    },
    {
      question: "Q2. What are the benefits of Sales Turnover Insurance?",
      answer: (
        <>
      The main benefits include comprehensive financial protection based on sales revenue, which can provide a more accurate measure of a business's exposure to risk compared to asset-based coverage. It ensures that a business can continue operations and maintain cash flow even in the face of significant disruptions, protecting long-term profitability.
       </>
      )
    },
    {
      question: "Q3. How are premiums calculated?",
      answer:(
        <>
         Premiums  are usually determined by factors like the <span style={{ color: "#F37435", fontWeight: "700"}}>business's expected annual sales, the type of business and industry, and the specific risks involved.</span> Insurers also look at past claims and how the business manages risks overall.

      </>
      )
      },

      {
        question: "Q4. Can the policy be customized?",
        answer:(
          <>
         <span style={{ color: "#F37435", fontWeight: "700"}}>Yes,</span> Sales Turnover Insurance policies can be tailored to meet the unique needs of a business. Customization options might include adjusting coverage limits, selecting specific risks to be covered, and adding endorsements for additional protections. This flexibility ensures that the policy aligns with the business’s specific risk profile and operational needs.
        </>
        )
        },
    {
      question: "Q5. What happens in the event of a claim?",
      answer: (
        <>
             In the event of a claim, the business must <span style={{ color: "#F37435", fontWeight: "700"}}>immediately notify the insurer and provide necessary documentation,</span> such as evidence of loss or damage and its impact on sales turnover. The <span style={{ color: "#F37435", fontWeight: "700"}}>insurer will assess the claim and provide compensation based on the policy terms, </span>helping the business recover and maintain financial stability during and after the disruption.
        </>
      )
      
    
    },
    {
      question: "Q6. How can I ensure that I have adequate coverage under a Sales Turnover?",
      answer: (
        <>
          To ensure that you have adequate coverage under a Sales Turnover Policy,it is important to:
          <ul style={{ listStyleType: "disc", marginLeft: "20px",color: "black"}}>
             <li  style={{ color: "black" }}>Accurately estimate your annual sales turnover</li>
             <li  style={{ color: "black" }}>Provide complete and accurate information to your insurance provider</li>
             <li  style={{ color: "black" }}> Regularly review and update your policy to reflect any changes in yourbusiness operations</li>
             <li  style={{ color: "black" }}>Maintain proper documentation and records related to your insured transits</li> 
             <li  style={{ color: "black" }}>Cooperate with your insurance provider in the event of a claim</li>
          </ul>
         
        </>
      )
      
    },
    {
      question: "Q7. What documentation is required to purchase Sales Turnover Insurance?",
      answer: (
      
       <>
        To purchase Sales Turnover Insurance, businesses typically need to provide <span style={{ color: "#F37435", fontWeight: "700"}}>financial statements, sales reports, and projections of future sales turnover. </span>Insurers may also request details about the business’s operations, risk management practices, and historical claims data to accurately assess the risk and calculate premiums.
        </>

      )
      
    },
    
    
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default SalesTurnoverFAQ;